import React, { Component } from "react";

class FeelingProud extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsxlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 500 500" style={{enableBackground:"new 0 0 500 500",xmlSpace:"preserve"}}>
<g id="BACKGROUND">
	<rect style={{
  opacity: 0.1,
  fill: '{theme.imageHighlight}',
}}
 width="350" height="350"/>
	<g>
		
			<ellipse transform="matrix(0.7071 -0.7071 0.7071 0.7071 -87.847 243.4942)" style={{
  opacity: 0.3,
  fill: '#7371FC',
}}
 cx="250" cy="227.788" rx="195.686" ry="195.686"/>
		<g style={{
    opacity: 0.3,
  }}>
			
				<ellipse transform="matrix(0.7071 -0.7071 0.7071 0.7071 -87.847 243.4941)" style={{
  fill: 'none',
  stroke: '#7371FC',
  strokeWidth: 0.9049,
  strokeMiterlimit: 10,
  strokeDasharray: '4.0869,4.0869',
}} cx="250" cy="227.788" rx="205.533" ry="205.533"/>
		</g>
	</g>
	<g>
		<defs>
			
				<ellipse id="SVGID_1_" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -86.4689 242.9234)" cx="250" cy="225.839" rx="185.066" ry="185.066"/>
		</defs>
		<clipPath id="SVGID_00000068642977542220619290000012127461022841525691_">
    <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />

		</clipPath>
		
			<rect x="55.102" y="16.235" style={{
      clipPath: 'url(#SVGID_00000068642977542220619290000012127461022841525691_)',
      fill: '#EEEEFF',
    }} width="389.796" height="389.796"/>
		
			<rect x="187.441" y="4.896" style={{
      opacity: 0.4,
      clipPath: 'url(#SVGID_00000068642977542220619290000012127461022841525691_)',
      fill: '#7371FC',
    }} width="245.401" height="201.231"/>
		<g style={{
      opacity: 0.1,
      clipPath: 'url(#SVGID_00000068642977542220619290000012127461022841525691_)',
    }}>
			<g>
				
					<rect x="116.384" y="174.322" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 258.4068 359.7946)" style={{ fill: '#7371FC' }} width="25.639" height="11.15"/>
				
					<rect x="103.564" y="162.068" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 232.7676 335.286)" style={{ fill: '#7371FC' }} width="25.639" height="11.15"/>
			</g>
			<g>
				
					<rect x="411.148" y="237.11" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 847.9351 485.3704)" style={{ fill: '#7371FC' }} width="25.639" height="11.15"/>
				
					<rect x="398.328" y="224.856" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 822.2958 460.8618)" style={{ fill: '#7371FC' }} width="25.639" height="11.15"/>
			</g>
			<g>
				<rect x="135.613" y="110.357" style={{ fill: '#7371FC' }} width="25.639" height="11.15"/>
				<rect x="163.255" y="110.357" style={{ fill: '#7371FC' }} width="25.639" height="11.15"/>
				<rect x="149.259" y="123.542" style={{ fill: '#7371FC' }} width="25.639" height="11.151"/>
				<rect x="176.075" y="98.103" style={{ fill: '#7371FC' }} width="25.639" height="11.15"/>
			</g>
			<g>
				<rect x="130.205" y="251.237" style={{ fill: '#7371FC' }} width="25.639" height="11.15"/>
				<rect x="157.847" y="251.237" style={{ fill: '#7371FC' }} width="25.639" height="11.15"/>
				<rect x="143.851" y="264.421" style={{ fill: '#7371FC' }} width="25.639" height="11.151"/>
				<rect x="170.667" y="238.983" style={{ fill: '#7371FC' }} width="25.639" height="11.15"/>
			</g>
		</g>
		
			<rect x="68.815" y="272.179" style={{
      clipPath: 'url(#SVGID_00000068642977542220619290000012127461022841525691_)',
      fill: '#7371FC',
    }} width="374.355" height="148.849"/>
		<g style={{
  clipPath: 'url(#SVGID_00000068642977542220619290000012127461022841525691_)',
}}
>
			
				<rect x="367.487" y="267.948" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 835.2652 539.8315)" style={{ fill: '#2C54AC' }} width="100.292" height="3.935"/>
			<path style={{ fill: '#2C54AC' }} d="M352.531,216.45h61.987c1.932,0,3.68,1.466,4.45,3.732l17.574,51.702h-69.056l-17.293-50.874
				C349.462,218.856,350.695,216.45,352.531,216.45z"/>
			<path style={{ fill: '#0A2A6B' }} d="M349.097,216.45h64.252c1.519,0,2.893,1.152,3.498,2.934l17.846,52.5h-69.056l-17.925-52.732
				C347.279,217.876,348.009,216.45,349.097,216.45z"/>
			<path style={{ fill: '#9DDCF9' }} d="M381.511,244.167c0.706,4.202,4.684,7.609,8.886,7.609c4.202,0,7.036-3.407,6.331-7.609
				c-0.706-4.202-4.684-7.609-8.886-7.609C383.64,236.558,380.806,239.964,381.511,244.167z"/>
		</g>
		
			<rect x="194.985" y="4.896" style={{
  clipPath: 'url(#SVGID_00000068642977542220619290000012127461022841525691_)',
  fill: '#FFFFFF',
}}
 width="237.857" height="195.045"/>
		<g style={{
  opacity: 0.3,
  clipPath: 'url(#SVGID_00000068642977542220619290000012127461022841525691_)',
}}
>
			
				<rect x="346.169" y="146.645" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 705.2759 346.586)" style={{ fill: '#91C4FB' }} width="12.937" height="53.296"/>
			
				<rect x="326.391" y="139.596" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 665.7184 339.5372)" style={{ fill: '#7371FC' }} width="12.937" height="60.345"/>
			
				<rect x="306.612" y="132.951" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 626.1611 332.8924)" style={{ fill: '#32338C' }} width="12.937" height="66.99"/>
			
				<rect x="286.833" y="125.637" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 586.6036 325.5777)" style={{ fill: '#91C4FB' }} width="12.937" height="74.304"/>
			
				<rect x="267.055" y="117.497" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 547.0463 317.4382)" style={{ fill: '#7371FC' }} width="12.937" height="82.444"/>
			
				<rect x="247.276" y="107.766" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 507.4888 307.7072)" style={{ fill: '#32338C' }} width="12.937" height="92.175"/>
			
				<rect x="227.497" y="84.884" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 467.9315 284.8254)" style={{ fill: '#91C4FB' }} width="12.937" height="115.057"/>
			
				<rect x="207.719" y="66.412" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 428.374 266.3533)" style={{ fill: '#7371FC' }} width="12.937" height="133.529"/>
			<g>
				<path style={{ fill: '#91C4FB' }} d="M360.868,92.698c0,4.248-0.957,8.519-2.801,12.347l-1.424,2.987l-12.464-12.557l0.233-1.19
					c0.07-0.467,0.117-1.004,0.117-1.587c0-5.018-3.128-9.476-7.772-11.087l-1.564-0.56V64.433l2.754,0.514
					C351.228,67.397,360.868,79.067,360.868,92.698z"/>
				<path style={{ fill: '#32338C' }} d="M341.589,100.728l11.53,11.624l-1.867,1.634c-5.088,4.458-11.624,6.932-18.392,6.932
					c-6.769,0-13.304-2.474-18.393-6.932l-1.867-1.634l11.53-11.624l1.634,1.307c4.038,3.198,10.153,3.198,14.191,0L341.589,100.728
					z"/>
				<path style={{ fill: '#7371FC' }} d="M327.771,64.946l2.754-0.514v16.619l-1.564,0.56c-4.645,1.61-7.772,6.069-7.772,11.087
					c0,0.583,0.047,1.12,0.117,1.587l0.233,1.19l-12.464,12.557l-1.424-2.987c-1.844-3.828-2.801-8.099-2.801-12.347
					C304.85,79.067,314.49,67.397,327.771,64.946z"/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M233.811,64.433h69.61c0.789,0,1.429-0.64,1.429-1.429l0,0c0-0.789-0.64-1.429-1.429-1.429
					h-69.61c-0.789,0-1.429,0.64-1.429,1.429l0,0C232.382,63.793,233.022,64.433,233.811,64.433z"/>
				<path style={{ fill: '#7371FC' }} d="M233.811,69.27h69.61c0.789,0,1.429-0.64,1.429-1.429l0,0c0-0.789-0.64-1.429-1.429-1.429h-69.61
					c-0.789,0-1.429,0.64-1.429,1.429l0,0C232.382,68.63,233.022,69.27,233.811,69.27z"/>
				<path style={{ fill: '#7371FC' }} d="M233.811,74.107h69.61c0.789,0,1.429-0.64,1.429-1.429l0,0c0-0.789-0.64-1.429-1.429-1.429
					h-69.61c-0.789,0-1.429,0.64-1.429,1.429l0,0C232.382,73.467,233.022,74.107,233.811,74.107z"/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M367.353,150.64h69.61c0.789,0,1.429-0.64,1.429-1.429l0,0c0-0.789-0.64-1.429-1.429-1.429
					h-69.61c-0.789,0-1.429,0.64-1.429,1.429l0,0C365.924,150.001,366.563,150.64,367.353,150.64z"/>
				<path style={{ fill: '#7371FC' }} d="M367.353,155.477h69.61c0.789,0,1.429-0.64,1.429-1.429l0,0c0-0.789-0.64-1.429-1.429-1.429
					h-69.61c-0.789,0-1.429,0.64-1.429,1.429l0,0C365.924,154.838,366.563,155.477,367.353,155.477z"/>
				<path style={{ fill: '#7371FC' }} d="M367.353,160.314h69.61c0.789,0,1.429-0.64,1.429-1.429l0,0c0-0.789-0.64-1.429-1.429-1.429
					h-69.61c-0.789,0-1.429,0.64-1.429,1.429l0,0C365.924,159.675,366.563,160.314,367.353,160.314z"/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M367.353,165.525h69.61c0.789,0,1.429-0.64,1.429-1.429l0,0c0-0.789-0.64-1.429-1.429-1.429
					h-69.61c-0.789,0-1.429,0.64-1.429,1.429l0,0C365.924,164.885,366.563,165.525,367.353,165.525z"/>
				<path style={{ fill: '#7371FC' }} d="M367.353,170.362h69.61c0.789,0,1.429-0.64,1.429-1.429l0,0c0-0.789-0.64-1.429-1.429-1.429
					h-69.61c-0.789,0-1.429,0.64-1.429,1.429l0,0C365.924,169.722,366.563,170.362,367.353,170.362z"/>
				<path style={{ fill: '#7371FC' }} d="M367.353,175.199h69.61c0.789,0,1.429-0.64,1.429-1.429l0,0c0-0.789-0.64-1.429-1.429-1.429
					h-69.61c-0.789,0-1.429,0.64-1.429,1.429l0,0C365.924,174.559,366.563,175.199,367.353,175.199z"/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M367.353,180.409h69.61c0.789,0,1.429-0.64,1.429-1.429l0,0c0-0.789-0.64-1.429-1.429-1.429
					h-69.61c-0.789,0-1.429,0.64-1.429,1.429l0,0C365.924,179.77,366.563,180.409,367.353,180.409z"/>
				<path style={{ fill: '#7371FC' }} d="M367.353,185.247h69.61c0.789,0,1.429-0.64,1.429-1.429l0,0c0-0.789-0.64-1.429-1.429-1.429
					h-69.61c-0.789,0-1.429,0.64-1.429,1.429l0,0C365.924,184.607,366.563,185.247,367.353,185.247z"/>
				<path style={{ fill: '#7371FC' }} d="M367.353,190.084h69.61c0.789,0,1.429-0.64,1.429-1.429l0,0c0-0.789-0.64-1.429-1.429-1.429
					h-69.61c-0.789,0-1.429,0.64-1.429,1.429l0,0C365.924,189.444,366.563,190.084,367.353,190.084z"/>
			</g>
			<g>
				<path style={{ fill: '#91C4FB' }} d="M293.884,77.674h-15.348c-2.768,0-5.013,2.244-5.013,5.013l0,0c0,2.768,2.244,5.013,5.013,5.013
					h15.348V77.674z"/>
				<path style={{ fill: '#32338C' }} d="M293.884,87.7L293.884,87.7c2.768,0,5.013-2.244,5.013-5.013l0,0
					c0-2.769-2.244-5.013-5.013-5.013l0,0c-2.768,0-5.013,2.244-5.013,5.013l0,0C288.871,85.456,291.116,87.7,293.884,87.7z"/>
			</g>
			<g>
				<path style={{ fill: '#91C4FB' }} d="M264.653,77.674h-15.348c-2.769,0-5.013,2.244-5.013,5.013l0,0c0,2.768,2.244,5.013,5.013,5.013
					h15.348V77.674z"/>
				<path style={{ fill: '#32338C' }} d="M264.653,87.7L264.653,87.7c2.768,0,5.013-2.244,5.013-5.013l0,0
					c0-2.769-2.244-5.013-5.013-5.013l0,0c-2.768,0-5.013,2.244-5.013,5.013l0,0C259.64,85.456,261.884,87.7,264.653,87.7z"/>
			</g>
			<g>
				<g>
					
						<line style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
}}
 x1="194.878" y1="87.434" x2="195.822" y2="86.654"/>
					
						<line style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
  strokeDasharray: '2.3916,2.3916',
}} x1="197.667" y1="85.132" x2="215.192" y2="70.671"/>
					<polyline style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
}}
 points="216.114,69.91 217.059,69.131 
						217.873,70.046 					"/>
					
						<line style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
  strokeDasharray: '2.5109,2.5109',
}}
 x1="219.542" y1="71.921" x2="252.096" y2="108.495"/>
					<polyline style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
}}
 points="252.93,109.433 
						253.745,110.348 254.655,109.529 					"/>
					
						<line style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
  strokeDasharray: '2.6833,2.6833',
}} x1="256.651" y1="107.734" x2="271.615" y2="94.278"/>
					<polyline style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
}}
 points="272.612,93.381 273.523,92.562 
						274.349,93.467 					"/>
					
						<line style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
  strokeDasharray: '2.5733,2.5733',
}} x1="276.084" y1="95.367" x2="302.976" y2="124.824"/>
					<polyline style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
}}
 points="303.844,125.774 
						304.67,126.678 305.544,125.821 					"/>
					
						<line style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
  strokeDasharray: '2.5825,2.5825',
}}
 x1="307.387" y1="124.012" x2="335.962" y2="95.979"/>
					<polyline style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
}}
 points="336.884,95.075 337.759,94.217 
						338.626,95.082 					"/>
					
						<line style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
  strokeDasharray: '2.557,2.557',
}}x1="340.438" y1="96.886" x2="375.771" y2="132.068"/>
					<polyline style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
}}
 points="376.677,132.97 
						377.545,133.834 378.411,132.968 					"/>
					
						<line style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
  strokeDasharray: '2.4493,2.4493',
}}
 x1="380.143" y1="131.236" x2="396.596" y2="114.783"/>
					
						<line style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 0.4083,
  strokeMiterlimit: 10,
}}
 x1="397.462" y1="113.917" x2="398.328" y2="113.051"/>
				</g>
			</g>
		</g>
		<g style={{
  clipPath: 'url(#SVGID_00000068642977542220619290000012127461022841525691_)',
}}
>
			<rect x="64.396" y="197.436" style={{ fill: '#91C4FB' }} width="19.832" height="74.742"/>
			<rect x="64.396" y="210.555" style={{ fill: '#EEEEFF' }} width="19.832" height="2.823"/>
			<rect x="64.396" y="216.169" style={{ fill: '#EEEEFF' }} width="19.832" height="2.824"/>
			<path style={{ fill: '#EEEEFF' }} d="M79.225,228.127c0,2.713-2.2,4.913-4.913,4.913c-2.713,0-4.913-2.2-4.913-4.913
				c0-2.714,2.2-4.913,4.913-4.913C77.025,223.214,79.225,225.414,79.225,228.127z"/>
			<rect x="84.228" y="217.581" style={{ fill: '#7371FC' }} width="19.832" height="54.598"/>
			<rect x="104.06" y="205.799" style={{ fill: '#32338C' }} width="19.832" height="66.379"/>
			<rect x="123.891" y="190.396" style={{ fill: '#91C4FB' }} width="19.832" height="81.783"/>
			<rect x="84.228" y="230.699" style={{ fill: '#32338C' }} width="19.832" height="2.823"/>
			<rect x="84.228" y="262.07" style={{ fill: '#32338C' }} width="19.832" height="2.823"/>
			<rect x="123.891" y="253.986" style={{ fill: '#32338C' }} width="19.832" height="18.192"/>
			<rect x="123.891" y="249.344" style={{ fill: '#32338C' }} width="19.832" height="1.889"/>
			<rect x="123.891" y="197.436" style={{ fill: '#32338C' }} width="19.832" height="1.889"/>
		</g>
	</g>
</g>
<g id="OBJECTS">
	<g>
		<g>
			<g>
				<polygon style={{ fill: '#FE814B' }} points="254.728,163.874 240.697,163.874 237.751,184.8 254.728,197.518 				"/>
				<g>
					<path style={{ fill: '#32338C' }} d="M242.467,261.451c-0.54-29.178-9.883-59.426-14.695-73.157l-54.27,19.001
						c0,0-5.231,16.74-7.847,34.527c-2.616,17.787-2.616,41.327-2.616,41.327l-19.356,73.762l75.832,31.795
						C226.427,361.525,243.046,292.688,242.467,261.451z"/>
					<path style={{ fill: '#EEEEFF' }} d="M254.728,197.518L237.751,184.8l-9.979,3.494c4.811,13.731,14.154,43.979,14.695,73.157
						c0.578,31.237-16.04,100.075-22.951,127.255l35.211,14.763V197.518z"/>
				</g>
				<g>
					<path style={{ fill: '#7371FC' }} d="M185.011,350.191l2.176-13.165l2.287-13.144c0.748-4.384,1.576-8.753,2.36-13.131l2.389-13.125
						l0.005,0.214l-8.923-38.462c-2.934-12.83-5.849-25.665-8.657-38.525c3.221,12.763,6.335,25.55,9.43,38.343l9.163,38.406
						l0.025,0.106l-0.02,0.108l-2.472,13.11c-0.836,4.368-1.629,8.743-2.501,13.104l-2.575,13.091L185.011,350.191z"/>
				</g>
				<g>
					<path style={{ fill: '#7371FC' }} d="M234.632,210.68l-5.451,9.48l-5.518,9.439l-0.098,0.168l-0.203,0.002l-7.391,0.08l-7.391,0.033
						l0.413-0.678l7.933,15.258l7.829,15.311c2.628,5.094,5.162,10.237,7.746,15.354c2.575,5.122,5.105,10.266,7.616,15.422
						c-2.746-5.034-5.471-10.078-8.153-15.144c-2.672-5.072-5.394-10.118-8.022-15.212l-7.939-15.255l-7.835-15.308l-0.349-0.681
						l0.762,0.003l7.391,0.033l7.391,0.08l-0.301,0.17l5.753-9.298L234.632,210.68z"/>
				</g>
				<g>
					<path style={{ fill: '#7371FC' }} d="M221.265,190.572c-0.938,2.414-1.904,4.814-2.902,7.201c-1.011,2.381-1.983,4.779-3.027,7.145
						l-3.117,7.105c-1.036,2.37-2.14,4.709-3.207,7.065l-0.158-0.58c2.46,1.759,4.89,3.561,7.306,5.381
						c2.429,1.802,4.824,3.652,7.201,5.528c-2.55-1.632-5.083-3.29-7.581-4.995c-2.511-1.687-5.009-3.393-7.476-5.142l-0.315-0.224
						l0.158-0.356c1.048-2.365,2.058-4.746,3.136-7.097l3.226-7.056c1.07-2.354,2.212-4.676,3.315-7.016
						C218.941,195.199,220.088,192.879,221.265,190.572z"/>
				</g>
			</g>
			<g>
				<polygon style={{ fill: '#FE814B' }} points="254.728,163.874 268.758,163.874 271.704,184.8 254.728,197.518 				"/>
				<g>
					<path style={{ fill: '#32338C' }} d="M266.988,261.451c0.54-29.178,9.883-59.426,14.694-73.157l54.27,19.001
						c0,0,5.231,16.74,7.847,34.527c2.616,17.787,2.616,41.327,2.616,41.327l19.356,73.762l-75.832,31.795
						C283.029,361.525,266.41,292.688,266.988,261.451z"/>
					<path style={{ fill: '#EEEEFF' }} d="M254.728,197.518l16.976-12.719l9.979,3.494c-4.811,13.731-14.154,43.979-14.694,73.157
						c-0.578,31.237,16.04,100.075,22.951,127.255l-35.211,14.763V197.518z"/>
				</g>
				<g>
					<path style={{ fill: '#7371FC' }} d="M332.808,220.854l-4.269,19.276l-4.379,19.251l-4.452,19.233l-4.48,19.227l0.005-0.214
						l2.215,12.209c0.733,4.071,1.492,8.136,2.186,12.215c1.426,8.149,2.833,16.301,4.131,24.473
						c-1.716-8.095-3.324-16.21-4.912-24.329c-0.814-4.056-1.562-8.124-2.336-12.187l-2.307-12.192l-0.02-0.107l0.025-0.107
						l4.563-19.207l4.592-19.2l4.664-19.183L332.808,220.854z"/>
				</g>
				<g>
					<path style={{ fill: '#7371FC' }} d="M274.824,210.68l5.82,9.258l5.753,9.298l-0.301-0.17l7.391-0.08l7.391-0.033l0.762-0.003
						l-0.349,0.681l-7.835,15.308l-7.939,15.255c-2.628,5.094-5.35,10.14-8.022,15.212c-2.681,5.067-5.407,10.111-8.153,15.144
						c2.51-5.155,5.041-10.3,7.616-15.422c2.584-5.117,5.118-10.26,7.746-15.354l7.829-15.311l7.933-15.258l0.413,0.678
						l-7.391-0.033l-7.391-0.08l-0.203-0.002l-0.098-0.168l-5.518-9.439L274.824,210.68z"/>
				</g>
				<g>
					<path style={{ fill: '#7371FC' }} d="M288.191,190.572c1.176,2.307,2.324,4.627,3.441,6.96c1.103,2.34,2.245,4.662,3.315,7.016
						l3.226,7.056c1.078,2.351,2.089,4.732,3.136,7.097l0.158,0.356l-0.315,0.224c-2.467,1.749-4.965,3.455-7.476,5.142
						c-2.498,1.705-5.03,3.363-7.581,4.995c2.377-1.876,4.772-3.726,7.201-5.528c2.416-1.82,4.846-3.622,7.306-5.381l-0.158,0.58
						c-1.067-2.356-2.17-4.695-3.207-7.065l-3.117-7.105c-1.044-2.366-2.016-4.764-3.027-7.145
						C290.095,195.387,289.129,192.986,288.191,190.572z"/>
				</g>
			</g>
		</g>
		<polygon style={{ fill: '#7371FC' }} points="265.841,329.553 254.887,339.872 243.932,329.553 250.21,218.729 259.563,218.729 		"/>
		<g>
			<polygon style={{ fill: '#7371FC' }} points="250.21,218.729 244.719,209.992 254.728,197.518 265.712,209.995 259.563,218.729 			"/>
			<polyline style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 1.0463,
  strokeMiterlimit: 10,
}}
 points="234.709,222.465 254.728,197.518 
				276.691,222.465 			"/>
			
				<line style={{
  fill: 'none',
  stroke: '#32338C',
  strokeWidth: 1.0463,
  strokeMiterlimit: 10,
}}
 x1="250.21" y1="218.729" x2="259.563" y2="218.729"/>
		</g>
		<rect x="214.045" y="352.825" style={{ fill: '#32338C' }} width="81.826" height="53.036"/>
		<g>
			<path style={{ fill: '#32338C' }} d="M303.438,470.927c0,0,46.878,4.189,77.22,1.334c28.911-2.72,18.833-23.279,11.509-28.772
				c-7.324-5.493-22.756-11.509-35.05-11.509s-24.104,8.105-33.48,6.278c-9.376-1.828-14.386-6.278-14.386-6.278L303.438,470.927z"
				/>
			<path style={{ fill: '#32338C' }} d="M165.245,343.719c0,0-42.13,2.624-47.342,35.624c-5.212,33,79.917,65.575,98.159,71.656
				s87.376,19.928,87.376,19.928s8.907-12.67,9.82-22.719c0.914-10.048,1.827-22.38,1.827-22.38L165.245,343.719z"/>
			<g>
				<path style={{ fill: '#7371FC' }} d="M315.085,425.827c0.069,1.979,0.04,3.958,0.028,5.939c-0.048,1.979-0.125,3.957-0.222,5.936
					c-0.094,1.979-0.268,3.954-0.472,5.928c-0.203,1.974-0.445,3.946-0.791,5.911c-0.674,3.951-2.145,7.743-3.93,11.28
					c-1.805,3.543-3.883,6.936-6.26,10.105c1.005-1.706,1.995-3.414,2.903-5.167c0.935-1.736,1.829-3.493,2.632-5.288
					c1.618-3.584,3.047-7.24,3.627-11.118c0.743-3.851,1.092-7.789,1.492-11.712c0.194-1.964,0.359-3.932,0.512-5.902
					L315.085,425.827z"/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M353.24,473.252c0.726-1.696,1.115-3.479,1.422-5.255c0.273-1.785,0.404-3.587,0.385-5.39
					c-0.002-1.807-0.127-3.614-0.393-5.4c-0.285-1.78-0.65-3.57-1.414-5.248c1.124,1.481,1.789,3.283,2.216,5.092
					c0.442,1.818,0.617,3.687,0.637,5.55c-0.001,1.867-0.184,3.742-0.634,5.558C355.008,469.966,354.326,471.746,353.24,473.252z"/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M347.268,473.252c0.726-1.696,1.115-3.479,1.422-5.255c0.273-1.785,0.404-3.587,0.385-5.39
					c-0.002-1.807-0.127-3.614-0.393-5.4c-0.285-1.78-0.65-3.57-1.414-5.248c1.124,1.481,1.789,3.283,2.216,5.092
					c0.442,1.818,0.617,3.687,0.637,5.55c-0.001,1.867-0.184,3.742-0.634,5.558C349.036,469.966,348.353,471.746,347.268,473.252z"
					/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M341.296,473.252c0.726-1.696,1.115-3.479,1.422-5.255c0.273-1.785,0.404-3.587,0.385-5.39
					c-0.001-1.807-0.127-3.614-0.393-5.4c-0.285-1.78-0.65-3.57-1.414-5.248c1.124,1.481,1.789,3.283,2.216,5.092
					c0.442,1.818,0.617,3.687,0.637,5.55c-0.001,1.867-0.184,3.742-0.634,5.558C343.064,469.966,342.381,471.746,341.296,473.252z"
					/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M335.324,473.252c0.726-1.696,1.115-3.479,1.422-5.255c0.273-1.785,0.404-3.587,0.385-5.39
					c-0.002-1.807-0.127-3.614-0.393-5.4c-0.285-1.78-0.65-3.57-1.414-5.248c1.124,1.481,1.789,3.283,2.216,5.092
					c0.442,1.818,0.617,3.687,0.637,5.55c-0.001,1.867-0.184,3.742-0.634,5.558C337.091,469.966,336.409,471.746,335.324,473.252z"
					/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M314.379,439.102c3.278,1.522,6.865,2.203,10.426,2.56c1.785,0.189,3.58,0.268,5.374,0.264
					c1.802,0.025,3.566-0.125,5.315-0.441c3.49-0.695,6.764-2.16,10.028-3.701c3.262-1.522,6.697-2.979,10.383-3.418
					c3.676-0.509,7.393,0.098,10.894,1.024c3.519,0.931,6.945,2.135,10.289,3.52c6.698,2.745,13.202,5.92,19.494,9.464
					c-3.245-1.582-6.506-3.125-9.81-4.57c-3.291-1.472-6.613-2.871-9.979-4.145c-3.369-1.259-6.759-2.479-10.232-3.347
					c-3.46-0.882-7.02-1.423-10.527-0.91c-3.52,0.386-6.848,1.754-10.117,3.245c-3.266,1.491-6.64,3.031-10.28,3.625
					c-1.81,0.28-3.66,0.384-5.466,0.31c-1.814-0.047-3.627-0.167-5.425-0.416c-1.797-0.25-3.581-0.599-5.326-1.086
					C317.678,440.592,315.952,439.996,314.379,439.102z"/>
			</g>
		</g>
		<g>
			<path style={{ fill: '#32338C' }} d="M293.665,86.995c0,18.236-17.964,18.622-40.124,18.622c-22.16,0-40.124-0.386-40.124-18.622
				c0-18.236,17.964-26.573,40.124-26.573C275.701,60.422,293.665,68.759,293.665,86.995z"/>
			<path style={{ fill: '#FE814B' }} d="M293.036,114.928c0,27.742-17.683,56.901-39.496,56.901s-39.496-29.159-39.496-56.901
				s17.683-40.424,39.496-40.424S293.036,87.186,293.036,114.928z"/>
			<g>
				<path style={{ fill: '#32338C' }} d="M232.477,117.755c0.99,1.536,1.997,3.009,3.185,4.22c1.174,1.217,2.575,2.096,4.02,2.102
					c1.445,0.017,2.841-0.849,4.006-2.072c1.178-1.216,2.167-2.702,3.137-4.25c-0.268,1.818-0.931,3.592-2.046,5.153
					c-0.555,0.783-1.238,1.508-2.103,2.074c-0.871,0.55-1.926,0.885-3.008,0.91c-1.083-0.035-2.126-0.394-2.988-0.946
					c-0.862-0.563-1.543-1.286-2.1-2.064C233.46,121.33,232.772,119.569,232.477,117.755z"/>
			</g>
			<g>
				<path style={{ fill: '#32338C' }} d="M263.469,117.755c0.99,1.536,1.997,3.008,3.185,4.22c1.174,1.217,2.575,2.096,4.02,2.102
					c1.445,0.017,2.841-0.849,4.006-2.072c1.178-1.216,2.167-2.702,3.137-4.25c-0.268,1.818-0.931,3.592-2.046,5.153
					c-0.555,0.783-1.238,1.508-2.103,2.074c-0.871,0.55-1.926,0.885-3.008,0.91c-1.083-0.035-2.126-0.394-2.988-0.946
					c-0.862-0.563-1.543-1.286-2.1-2.064C264.451,121.33,263.763,119.569,263.469,117.755z"/>
			</g>
			<g>
				<path style={{ fill: '#32338C' }} d="M228.675,113.288c0.924-1.903,2.22-3.637,3.738-5.169c1.547-1.502,3.34-2.78,5.314-3.75
					c1.965-0.952,4.096-1.804,6.335-1.825c2.213-0.037,4.459,0.379,6.37,1.502l-0.054,0.236c-2.169,0.195-4.147,0.342-6.1,0.677
					c-1.927,0.351-3.906,0.512-5.792,1.195c-1.877,0.665-3.666,1.643-5.278,2.881c-1.641,1.208-3.085,2.702-4.325,4.379
					L228.675,113.288z"/>
			</g>
			<g>
				<path style={{ fill: '#32338C' }} d="M280.195,113.413c-1.24-1.677-2.683-3.171-4.325-4.379c-1.612-1.238-3.402-2.216-5.278-2.881
					c-1.885-0.684-3.865-0.845-5.792-1.195c-1.953-0.335-3.931-0.482-6.1-0.677l-0.054-0.236c1.91-1.123,4.157-1.539,6.369-1.502
					c2.239,0.021,4.37,0.873,6.335,1.825c1.974,0.97,3.767,2.248,5.314,3.75c1.518,1.532,2.814,3.266,3.738,5.169L280.195,113.413z"
					/>
			</g>
			<g>
				<path style={{ fill: '#32338C' }} d="M254.219,115.682c1.49,1.86,2.641,3.979,3.652,6.141c0.987,2.178,1.798,4.434,2.469,6.729
					c0.652,2.309,1.132,4.681,1.336,7.089c0.109,1.203,0.151,2.415,0.095,3.628c-0.058,1.223-0.157,2.404-0.488,3.662l-0.122,0.464
					l-0.461-0.014c-1.712-0.052-3.423-0.135-5.135-0.227c-1.712-0.126-3.423-0.202-5.135-0.376c1.712-0.173,3.423-0.249,5.135-0.375
					c1.712-0.092,3.423-0.175,5.135-0.227l-0.583,0.45c0.352-2.176,0.26-4.558,0.037-6.839c-0.26-2.299-0.666-4.59-1.262-6.842
					c-0.566-2.27-1.234-4.514-1.991-6.732C256.131,119.998,255.305,117.793,254.219,115.682z"/>
			</g>
			<path style={{ fill: '#32338C' }} d="M211.09,125.754c0,0,11.088-2.952,14.593-21.586s-12.335-20.778-16.728-17.957
				C202.253,90.516,195.943,117.821,211.09,125.754z"/>
			<path style={{ fill: '#32338C' }} d="M296.859,125.754c0,0-11.088-2.952-14.594-21.586S294.6,83.39,298.994,86.212
				C305.696,90.516,312.006,117.821,296.859,125.754z"/>
			<path style={{ fill: '#32338C' }} d="M217.689,87.564c0,0,17.068,11.254,37.038,11.254c19.97,0,35.099-9.594,35.099-9.594
				s-12.73-19.187-34.131-19.003C234.294,70.406,217.689,87.564,217.689,87.564z"/>
			<g>
				<g>
					<path style={{ fill: '#FE814B' }} d="M216.619,120.822c-1.602-2.218-4.595-3.719-7.201-2.785c-1.91,0.684-3.175,2.475-3.983,4.302
						c-2.498,5.647-1.447,12.82,3.088,17.082c1.217,1.144,2.725,2.097,4.407,2.237c2.993,0.249,5.658-2.21,6.612-4.997
						c0.868-2.532,0.95-5.781,0.044-8.31C218.688,125.845,218.214,123.03,216.619,120.822z"/>
					<g>
						<path style={{ fill: '#F07167' }} d="M215.048,139.059c-0.968-0.788-1.922-1.848-2.114-3.324c-0.031-0.235-0.039-0.491,0.05-0.708
							c0.082-0.201,0.234-0.338,0.382-0.461c1.01-0.834,2.149-1.394,3.317-1.63c-0.115-2.408-0.243-4.889-1.071-7.011
							c-0.827-2.122-2.541-3.819-4.411-3.531c-1.463,0.226-2.797,1.735-3.171,3.586c0,0-1.251,3.601,0.465,7.931
							C210.21,138.241,215.048,139.059,215.048,139.059z"/>
						<g>
							<path style={{ fill: '#32338C' }} d="M208.03,125.98c0.119-1.508,0.925-3.144,2.544-3.867c0.816-0.361,1.802-0.294,2.605,0.067
								c0.813,0.355,1.461,0.947,1.979,1.599c1.068,1.317,1.529,2.948,1.825,4.485c0.251,1.565,0.331,3.116,0.346,4.641l0.005,0.574
								l-0.523,0.09c-0.675,0.116-1.336,0.347-1.97,0.656c-0.316,0.157-0.621,0.339-0.916,0.541c-0.141,0.1-0.311,0.215-0.403,0.291
								c-0.096,0.086-0.133,0.126-0.167,0.24c-0.064,0.229-0.015,0.626,0.048,0.953c0.065,0.342,0.181,0.679,0.339,1.003
								c0.312,0.652,0.785,1.248,1.306,1.805c-0.647-0.402-1.266-0.892-1.739-1.542c-0.235-0.324-0.435-0.682-0.582-1.068
								c-0.13-0.399-0.26-0.761-0.224-1.288c0.019-0.263,0.17-0.572,0.342-0.755c0.174-0.194,0.311-0.305,0.467-0.439
								c0.308-0.258,0.633-0.499,0.977-0.715c0.686-0.437,1.454-0.762,2.266-0.948l-0.517,0.664
								c-0.131-1.516-0.202-3.016-0.471-4.454c-0.24-1.442-0.656-2.828-1.441-3.957c-0.774-1.115-1.982-1.984-3.266-1.629
								C209.58,123.293,208.524,124.55,208.03,125.98z"/>
						</g>
					</g>
				</g>
				<g>
					<path style={{ fill: '#FE814B' }} d="M290.691,120.822c1.602-2.218,4.595-3.719,7.201-2.785c1.91,0.684,3.175,2.475,3.983,4.302
						c2.498,5.647,1.447,12.82-3.088,17.082c-1.217,1.144-2.725,2.097-4.407,2.237c-2.992,0.249-5.658-2.21-6.612-4.997
						c-0.868-2.532-0.95-5.781-0.044-8.31C288.622,125.845,289.096,123.03,290.691,120.822z"/>
					<g>
						<path style={{ fill: '#F07167' }} d="M292.262,139.059c0.968-0.788,1.922-1.848,2.114-3.324c0.031-0.235,0.039-0.491-0.05-0.708
							c-0.082-0.201-0.234-0.338-0.382-0.461c-1.009-0.834-2.149-1.394-3.317-1.63c0.115-2.408,0.243-4.889,1.071-7.011
							c0.828-2.122,2.541-3.819,4.411-3.531c1.463,0.226,2.797,1.735,3.171,3.586c0,0,1.251,3.601-0.465,7.931
							C297.1,138.241,292.262,139.059,292.262,139.059z"/>
						<g>
							<path style={{ fill: '#32338C' }} d="M299.28,125.98c-0.495-1.43-1.55-2.687-2.829-3.055c-1.284-0.355-2.492,0.514-3.266,1.629
								c-0.785,1.13-1.201,2.515-1.441,3.957c-0.269,1.439-0.34,2.939-0.471,4.454l-0.517-0.664c0.812,0.186,1.58,0.511,2.266,0.948
								c0.344,0.216,0.669,0.457,0.977,0.715c0.156,0.135,0.293,0.246,0.467,0.439c0.172,0.182,0.323,0.492,0.342,0.755
								c0.036,0.527-0.094,0.889-0.224,1.288c-0.147,0.386-0.347,0.745-0.582,1.068c-0.473,0.65-1.092,1.141-1.739,1.542
								c0.522-0.557,0.994-1.153,1.306-1.805c0.158-0.324,0.273-0.661,0.339-1.003c0.063-0.328,0.112-0.725,0.048-0.953
								c-0.034-0.114-0.071-0.154-0.168-0.24c-0.092-0.076-0.262-0.192-0.403-0.291c-0.295-0.202-0.601-0.384-0.916-0.541
								c-0.634-0.309-1.295-0.54-1.97-0.656l-0.523-0.09l0.005-0.574c0.015-1.525,0.095-3.075,0.346-4.641
								c0.295-1.537,0.757-3.168,1.825-4.485c0.519-0.652,1.166-1.244,1.979-1.599c0.803-0.362,1.789-0.429,2.605-0.067
								C298.355,122.836,299.161,124.472,299.28,125.98z"/>
						</g>
					</g>
				</g>
			</g>
			<g>
				<path style={{ fill: '#32338C' }} d="M236.801,165.876c1.443,0.93,2.946,1.733,4.513,2.38c1.551,0.675,3.15,1.218,4.766,1.665
					c3.236,0.849,6.608,1.271,9.905,1.06c0.825,0.003,1.636-0.184,2.455-0.276c0.805-0.181,1.621-0.333,2.412-0.581
					c1.61-0.419,3.139-1.104,4.666-1.793c3-1.496,5.874-3.343,8.48-5.576c-2.175,2.666-4.883,4.919-7.909,6.659
					c-3.035,1.707-6.444,2.931-10.004,3.132l-1.331,0.057l-1.315-0.05c-0.878-0.012-1.749-0.139-2.62-0.234
					c-1.728-0.29-3.449-0.644-5.097-1.232C242.43,169.947,239.314,168.235,236.801,165.876z"/>
			</g>
			<g>
				<path style={{ fill: '#F07167' }} d="M251.634,155.742c0.649,0.778,2.253,1.331,4.14,1.331c1.77,0,3.286-0.489,4.005-1.191
					c-0.915-0.49-2.211-0.901-4.005-0.901C253.957,154.981,252.606,155.33,251.634,155.742z"/>
				<path style={{ fill: '#32338C' }} d="M260.229,154.981c0-1.156-1.995-2.092-4.455-2.092c-2.46,0-4.455,0.937-4.455,2.092
					c0,0.269,0.118,0.525,0.315,0.761c0.972-0.412,2.324-0.761,4.14-0.761c1.794,0,3.089,0.411,4.005,0.901
					C260.059,155.608,260.229,155.305,260.229,154.981z"/>
			</g>
		</g>
		<g>
			<path style={{ fill: '#32338C' }} d="M190.562,470.927c0,0-46.878,4.189-77.22,1.334c-28.911-2.72-18.833-23.279-11.509-28.772
				c7.324-5.493,22.756-11.509,35.05-11.509c12.294,0,24.104,8.105,33.48,6.278c9.376-1.828,14.386-6.278,14.386-6.278
				L190.562,470.927z"/>
			<path style={{ fill: '#32338C' }} d="M328.755,343.719c0,0,42.13,2.624,47.342,35.624c5.212,33-79.917,65.575-98.159,71.656
				c-18.242,6.081-87.376,19.928-87.376,19.928s-8.907-12.67-9.82-22.719c-0.913-10.048-1.827-22.38-1.827-22.38L328.755,343.719z"
				/>
			<g>
				<path style={{ fill: '#7371FC' }} d="M321.207,363.221c-11.412,6.152-22.912,12.148-34.554,17.861
					c-5.812,2.875-11.664,5.67-17.534,8.428c-5.898,2.697-11.802,5.387-17.787,7.895c-5.978,2.533-12.019,4.898-18.029,7.315
					l-18.072,7.177c-12.058,4.76-24.091,9.58-36.171,14.286l0.24-0.364c0.079,3.942,0.259,7.892,0.526,11.829
					c0.288,3.935,0.635,7.874,1.297,11.756c0.584,3.9,1.987,7.615,3.651,11.19c1.681,3.571,3.628,7.022,5.79,10.332
					c-2.228-3.266-4.247-6.679-6.005-10.228c-1.739-3.545-3.236-7.279-3.906-11.208c-0.75-3.901-1.115-7.851-1.457-11.794
					c-0.312-3.948-0.538-7.898-0.662-11.861l-0.008-0.263l0.248-0.101c12.008-4.888,24.063-9.661,36.093-14.495l18.06-7.214
					c6.026-2.398,12.067-4.737,18.036-7.24c11.938-5.021,23.702-10.467,35.4-16.042C298.037,374.858,309.68,369.155,321.207,363.221
					z"/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M140.76,473.252c-1.085-1.506-1.768-3.286-2.219-5.093c-0.45-1.816-0.632-3.691-0.634-5.558
					c0.02-1.863,0.195-3.732,0.637-5.55c0.427-1.808,1.092-3.611,2.216-5.092c-0.765,1.678-1.129,3.469-1.414,5.248
					c-0.266,1.786-0.391,3.593-0.393,5.4c-0.019,1.803,0.112,3.605,0.385,5.39C139.645,469.772,140.034,471.556,140.76,473.252z"/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M146.732,473.252c-1.086-1.506-1.768-3.286-2.219-5.093c-0.45-1.816-0.633-3.691-0.634-5.558
					c0.02-1.863,0.196-3.732,0.637-5.55c0.427-1.808,1.092-3.611,2.216-5.092c-0.765,1.678-1.129,3.469-1.415,5.248
					c-0.266,1.786-0.391,3.593-0.393,5.4c-0.019,1.803,0.112,3.605,0.385,5.39C145.617,469.772,146.006,471.556,146.732,473.252z"/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M152.704,473.252c-1.085-1.506-1.768-3.286-2.219-5.093c-0.45-1.816-0.633-3.691-0.634-5.558
					c0.02-1.863,0.195-3.732,0.637-5.55c0.427-1.808,1.092-3.611,2.216-5.092c-0.764,1.678-1.129,3.469-1.414,5.248
					c-0.266,1.786-0.391,3.593-0.393,5.4c-0.019,1.803,0.112,3.605,0.385,5.39C151.589,469.772,151.978,471.556,152.704,473.252z"/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M158.676,473.252c-1.085-1.506-1.768-3.286-2.219-5.093c-0.45-1.816-0.633-3.691-0.634-5.558
					c0.02-1.863,0.195-3.732,0.637-5.55c0.427-1.808,1.092-3.611,2.216-5.092c-0.765,1.678-1.129,3.469-1.415,5.248
					c-0.266,1.786-0.391,3.593-0.393,5.4c-0.019,1.803,0.112,3.605,0.385,5.39C157.561,469.772,157.95,471.556,158.676,473.252z"/>
			</g>
			<g>
				<path style={{ fill: '#7371FC' }} d="M179.622,439.102c-1.573,0.894-3.3,1.49-5.041,1.981c-1.745,0.488-3.529,0.836-5.326,1.086
					c-1.798,0.249-3.611,0.369-5.425,0.416c-1.806,0.073-3.657-0.03-5.467-0.31c-3.639-0.594-7.014-2.134-10.28-3.625
					c-3.27-1.491-6.597-2.859-10.117-3.245c-3.507-0.513-7.067,0.027-10.527,0.91c-3.474,0.868-6.863,2.088-10.232,3.347
					c-3.366,1.274-6.688,2.673-9.979,4.145c-3.304,1.445-6.565,2.989-9.81,4.57c6.292-3.544,12.796-6.72,19.494-9.465
					c3.344-1.386,6.77-2.589,10.289-3.52c3.5-0.926,7.218-1.534,10.894-1.024c3.686,0.438,7.121,1.896,10.383,3.418
					c3.263,1.541,6.537,3.006,10.028,3.701c1.749,0.316,3.513,0.466,5.315,0.441c1.794,0.003,3.589-0.075,5.374-0.264
					C172.756,441.306,176.343,440.624,179.622,439.102z"/>
			</g>
		</g>
		<g>
			<path style={{ fill: '#7371FC' }} d="M280.464,349.128c1.44,4.297,4.164,8.003,7.8,10.479c1.799,1.259,3.841,2.152,5.968,2.732
				c2.129,0.598,4.379,0.684,6.646,0.882c-1.134,0.104-2.248,0.203-3.398,0.223c-0.575,0.024-1.148-0.007-1.721-0.065
				c-0.578-0.026-1.142-0.142-1.711-0.245c-2.267-0.44-4.458-1.346-6.373-2.663c-1.909-1.322-3.567-3.009-4.807-4.959
				C281.612,353.573,280.789,351.373,280.464,349.128z"/>
		</g>
		<g>
			<path style={{ fill: '#7371FC' }} d="M229.059,349.128c-0.325,2.245-1.149,4.445-2.403,6.384c-1.241,1.95-2.899,3.637-4.807,4.959
				c-1.914,1.317-4.106,2.223-6.373,2.663c-0.569,0.103-1.133,0.219-1.711,0.245c-0.573,0.058-1.146,0.089-1.721,0.065
				c-1.149-0.02-2.264-0.119-3.397-0.223c2.266-0.198,4.517-0.285,6.645-0.882c2.127-0.579,4.168-1.472,5.968-2.732
				C224.895,357.131,227.618,353.425,229.059,349.128z"/>
		</g>
		<g>
			<path style={{ fill: '#7371FC' }} d="M364.143,357.593c-4.284-2.589-8.917-4.569-13.701-5.964c-4.777-1.406-9.754-2.167-14.714-2.03
				c-2.477,0.072-4.945,0.362-7.364,0.879c-2.416,0.531-4.774,1.309-7.032,2.31c-4.486,2.118-8.872,4.538-13.126,7.151
				c-8.595,5.099-16.872,10.735-25.118,16.399c-4.125,2.832-8.214,5.718-12.281,8.634c-4.089,2.887-8.133,5.837-12.182,8.784
				c7.831-6.244,15.85-12.251,24-18.077c8.162-5.808,16.455-11.446,25.044-16.636c4.293-2.598,8.704-4.999,13.282-7.125
				c4.642-2.036,9.707-3.109,14.763-3.12C345.85,348.753,355.772,352.149,364.143,357.593z"/>
		</g>
		<g>
			<path style={{ fill: '#7371FC' }} d="M254.728,395.757c-4.231-3.181-8.485-6.327-12.792-9.399c-4.29-3.096-8.611-6.147-12.984-9.12
				c-8.736-5.957-17.594-11.747-26.787-16.951c-9.166-5.2-18.67-10.04-29.023-12.204c-5.131-1.183-10.383-1.925-15.652-1.897
				c-2.632,0.005-5.269,0.227-7.854,0.745c-1.291,0.263-2.567,0.605-3.808,1.053c-1.238,0.447-2.463,0.974-3.549,1.732
				c2.152-1.56,4.728-2.43,7.299-3.048c2.59-0.596,5.245-0.897,7.902-0.978c5.322-0.143,10.635,0.53,15.83,1.628
				c2.597,0.572,5.182,1.161,7.722,1.999c2.533,0.83,5.02,1.787,7.448,2.867c4.868,2.137,9.583,4.587,14.2,7.197
				c9.199,5.284,18.073,11.095,26.734,17.191C238.059,382.693,246.536,389.049,254.728,395.757z"/>
		</g>
		<g>
			<path style={{ fill: '#7371FC' }} d="M327.968,429.545c-7.052,3.884-14.269,7.466-21.587,10.832c-3.65,1.703-7.356,3.285-11.085,4.814
				c-3.722,1.545-7.497,2.966-11.299,4.316c-7.657,2.558-15.413,4.739-23.235,6.669c-7.827,1.901-15.7,3.614-23.64,4.947
				c3.927-0.883,7.847-1.781,11.75-2.756c3.909-0.943,7.808-1.928,11.69-2.97c7.761-2.086,15.511-4.258,23.094-6.878
				c7.594-2.597,15.027-5.668,22.397-8.874c3.692-1.59,7.353-3.253,11.001-4.947C320.714,433.031,324.344,431.296,327.968,429.545z"
				/>
		</g>
		<g>
			<path style={{ fill: '#FE814B' }} d="M168.474,363.435l-1.122,0.38c-1.437,0.486-3.025,0.021-3.972-1.164l0,0
				c-0.906-1.133-2.402-1.613-3.798-1.218l-2.214,0.626c-1.382,0.391-2.864-0.075-3.773-1.187l-0.906-1.108
				c-0.98-1.198-2.616-1.637-4.064-1.091l-2.59,0.977c-1.709,0.645-3.631-0.091-4.473-1.712l-0.008-0.015
				c-0.678-1.306-2.072-2.065-3.537-1.926c-3.822,0.362-7.768,1.415-11.993-4.466c-5.822-8.103-2.588-19.586-2.588-19.586
				s4.333,0.509,4.818,3.582c0.485,3.073,2.525,11.005,4.277,12.082c1.753,1.077,4.123-0.026,4.123-0.026s1.694-11.016,7.882-14.413
				c6.188-3.396,9.261-3.882,9.261-3.882s4.852-4.852,7.763-4.529c2.911,0.323,0.324,7.925,0.324,7.925s3.558-6.469,5.822-5.984
				c2.264,0.485,0.809,8.086,0.809,8.086s0.97-6.631,3.882-6.307c2.616,0.291,0.405,24.774-1.598,32.481
				C170.497,362.125,169.613,363.049,168.474,363.435z"/>
			<g>
				<path style={{ fill: '#32338C' }} d="M168.812,333.047c-0.436,4.932-1.173,9.807-2.149,14.657c-1.017,4.832-2.325,9.656-4.429,14.149
					c1.204-4.801,2.272-9.573,3.254-14.393C166.495,342.651,167.447,337.808,168.812,333.047z"/>
			</g>
			<g>
				<path style={{ fill: '#32338C' }} d="M162.248,331.854c-1.808,4.481-3.738,8.863-5.56,13.299c-1.855,4.422-3.599,8.88-5.501,13.323
					c0.997-4.732,2.557-9.32,4.393-13.783C157.449,340.243,159.601,335.901,162.248,331.854z"/>
			</g>
			<g>
				<path style={{ fill: '#32338C' }} d="M153.559,329.135l-3.931,5.825c-1.276,1.952-2.557,3.905-3.719,5.906
					c-1.183,1.994-2.203,4.052-3.038,6.214c-0.831,2.163-1.552,4.395-2.347,6.613c0.342-2.328,0.76-4.65,1.462-6.919
					c0.672-2.28,1.695-4.467,2.887-6.513C147.312,336.203,150.187,332.433,153.559,329.135z"/>
			</g>
		</g>
		<g>
			<path style={{ fill: '#FE814B' }} d="M345.693,364.481l1.122,0.38c1.437,0.486,3.025,0.021,3.972-1.164l0,0
				c0.906-1.133,2.402-1.613,3.798-1.218l2.214,0.626c1.382,0.391,2.864-0.075,3.773-1.187l0.906-1.108
				c0.98-1.198,2.615-1.637,4.064-1.091l2.59,0.977c1.709,0.645,3.631-0.091,4.473-1.712l0.008-0.015
				c0.678-1.306,2.072-2.065,3.537-1.926c3.822,0.362,7.768,1.415,11.993-4.466c5.822-8.103,2.588-19.586,2.588-19.586
				s-4.333,0.509-4.818,3.582c-0.485,3.073-2.525,11.005-4.277,12.082c-1.753,1.077-4.123-0.026-4.123-0.026
				s-1.694-11.016-7.882-14.413c-6.188-3.396-9.261-3.882-9.261-3.882s-4.852-4.852-7.763-4.528
				c-2.911,0.323-0.323,7.925-0.323,7.925s-3.558-6.469-5.822-5.984c-2.264,0.485-0.809,8.087-0.809,8.087s-0.97-6.631-3.882-6.308
				c-2.615,0.291-0.405,24.774,1.598,32.481C343.67,363.172,344.553,364.095,345.693,364.481z"/>
			<g>
				<path style={{ fill: '#32338C' }} d="M345.354,334.093c1.365,4.762,2.317,9.604,3.324,14.413c0.982,4.82,2.05,9.591,3.254,14.393
					c-2.104-4.493-3.411-9.317-4.429-14.149C346.527,343.9,345.79,339.026,345.354,334.093z"/>
			</g>
			<g>
				<path style={{ fill: '#32338C' }} d="M351.918,332.9c2.647,4.047,4.798,8.388,6.668,12.838c1.836,4.463,3.396,9.051,4.393,13.783
					c-1.903-4.442-3.646-8.901-5.501-13.323C355.656,341.763,353.727,337.382,351.918,332.9z"/>
			</g>
			<g>
				<path style={{ fill: '#32338C' }} d="M360.607,330.182c3.372,3.297,6.247,7.067,8.687,11.126c1.191,2.047,2.215,4.233,2.887,6.513
					c0.702,2.27,1.12,4.591,1.462,6.919c-0.795-2.218-1.515-4.45-2.347-6.613c-0.835-2.162-1.855-4.22-3.037-6.214
					c-1.162-2.001-2.444-3.954-3.72-5.906L360.607,330.182z"/>
			</g>
		</g>
		<g style={{
    opacity: 0.37,
  }}>
			<g>
				<path style={{ fill: '#EEEEFF' }} d="M210.148,85.986c1.449,2.297,2.612,4.783,3.462,7.375c0.858,2.591,1.391,5.286,1.661,8.003
					c0.228,2.721,0.191,5.468-0.181,8.172c-0.366,2.704-1.06,5.359-2.069,7.881c0.826-2.586,1.376-5.248,1.669-7.93
					c0.286-2.683,0.326-5.392,0.06-8.075c-0.224-2.687-0.756-5.344-1.523-7.931C212.453,90.896,211.43,88.379,210.148,85.986z"/>
			</g>
			<g>
				<path style={{ fill: '#EEEEFF' }} d="M204.294,93.569c1.332,3.546,1.833,7.391,1.7,11.187c-0.102,1.898-0.341,3.793-0.783,5.64
					c-0.441,1.847-1.05,3.654-1.864,5.361c0.612-1.788,1.116-3.603,1.471-5.446c0.355-1.842,0.594-3.705,0.654-5.578
					C205.662,100.988,205.209,97.232,204.294,93.569z"/>
			</g>
			<g>
				<path style={{ fill: '#EEEEFF' }} d="M295.873,85.376c-1.501,2.435-2.682,5.05-3.552,7.754c-0.863,2.707-1.429,5.509-1.628,8.342
					c-0.24,2.829-0.114,5.685,0.323,8.493c0.442,2.806,1.207,5.572,2.313,8.21c-1.283-2.558-2.193-5.312-2.71-8.142
					c-0.524-2.829-0.649-5.729-0.447-8.601c0.245-2.868,0.813-5.715,1.769-8.429C292.888,90.287,294.211,87.706,295.873,85.376z"/>
			</g>
			<g>
				<path style={{ fill: '#EEEEFF' }} d="M303.48,93.449c-1.302,1.815-2.31,3.815-3.07,5.892c-0.753,2.082-1.275,4.245-1.534,6.443
					c-0.301,2.194-0.346,4.419-0.265,6.637c0.087,2.22,0.309,4.439,0.61,6.651c-0.492-2.178-0.853-4.392-1.012-6.629
					c-0.165-2.236-0.116-4.492,0.149-6.726c0.307-2.228,0.832-4.435,1.678-6.521C300.874,97.111,302.025,95.148,303.48,93.449z"/>
			</g>
			<g>
				<path style={{ fill: '#EEEEFF' }} d="M292.264,79.571c-2.97,1.577-6.019,3.011-9.14,4.278c-3.129,1.245-6.329,2.314-9.583,3.19
					c-6.505,1.75-13.248,2.705-20.004,2.61c-6.751-0.152-13.481-1.394-19.805-3.75c-3.16-1.179-6.218-2.637-9.101-4.385
					c-2.87-1.768-5.564-3.82-8.003-6.136c2.497,2.254,5.235,4.23,8.135,5.916c2.888,1.708,5.938,3.135,9.089,4.278
					c6.305,2.287,12.999,3.457,19.694,3.554c6.701,0.153,13.413-0.737,19.905-2.424c3.249-0.842,6.445-1.886,9.579-3.092
					C286.174,82.427,289.255,81.073,292.264,79.571z"/>
			</g>
			<g>
				<path style={{ fill: '#EEEEFF' }} d="M220.768,70.744c1.852,1.107,3.901,1.83,5.993,2.288c2.09,0.485,4.23,0.715,6.371,0.856
					c4.281,0.297,8.59,0.044,12.816-0.666c4.233-0.69,8.364-1.934,12.334-3.558c3.956-1.662,7.728-3.771,11.234-6.274
					c-3.39,2.659-7.117,4.905-11.076,6.644c-3.968,1.715-8.141,2.967-12.405,3.703c-4.271,0.674-8.623,0.936-12.933,0.55
					C228.828,73.933,224.409,73.127,220.768,70.744z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<polygon style={{ fill: '#32338C' }} points="431.488,165.488 424.47,162.584 422.257,156.257 420.041,162.908 413.027,165.488 
				419.393,167.984 422.257,174.719 424.47,168.524 			"/>
			<g>
				<path style={{ fill: '#32338C' }} d="M405.937,119.7c2.041,0.725,4.082,1.1,6.122,1.371c2.04,0.256,4.082,0.375,6.122,0.378
					c2.041,0.003,4.081-0.117,6.122-0.373c2.041-0.27,4.082-0.646,6.123-1.376c-2.041-0.729-4.082-1.106-6.123-1.375
					c-2.041-0.256-4.081-0.376-6.122-0.373c-2.041,0.002-4.082,0.121-6.122,0.378C410.018,118.6,407.978,118.976,405.937,119.7z"/>
				<path style={{ fill: '#32338C' }} d="M418.181,107.456c-0.725,2.041-1.101,4.082-1.371,6.122c-0.257,2.041-0.376,4.081-0.378,6.122
					c-0.003,2.041,0.117,4.082,0.373,6.122c0.27,2.041,0.647,4.082,1.376,6.122c0.729-2.04,1.106-4.082,1.375-6.122
					c0.256-2.041,0.376-4.081,0.373-6.122c-0.002-2.041-0.121-4.081-0.378-6.122C419.282,111.538,418.906,109.497,418.181,107.456z"
					/>
				<path style={{ fill: '#32338C' }} d="M409.523,128.359c1.955-0.931,3.664-2.108,5.298-3.36c1.624-1.262,3.152-2.62,4.596-4.062
					c1.445-1.441,2.804-2.968,4.065-4.593c1.253-1.634,2.429-3.343,3.357-5.302c-1.959,0.927-3.668,2.104-5.302,3.357
					c-1.624,1.262-3.152,2.62-4.593,4.065c-1.441,1.444-2.8,2.972-4.062,4.596C411.631,124.694,410.454,126.403,409.523,128.359z"/>
				<path style={{ fill: '#32338C' }} d="M409.523,111.043c0.931,1.955,2.108,3.664,3.359,5.298c1.262,1.624,2.621,3.152,4.062,4.596
					c1.441,1.445,2.969,2.804,4.593,4.065c1.634,1.252,3.343,2.429,5.302,3.356c-0.927-1.959-2.104-3.668-3.357-5.301
					c-1.262-1.625-2.62-3.152-4.065-4.593c-1.444-1.442-2.972-2.8-4.596-4.062C413.187,113.15,411.478,111.973,409.523,111.043z"/>
			</g>
			<g>
				<path style={{ fill: '#32338C' }} d="M390.039,147.061c1.325,0.471,2.649,0.714,3.974,0.89c1.324,0.166,2.65,0.244,3.974,0.245
					c1.324,0.002,2.649-0.076,3.974-0.242c1.325-0.175,2.649-0.42,3.974-0.893c-1.325-0.473-2.649-0.718-3.974-0.893
					c-1.325-0.166-2.649-0.244-3.974-0.242c-1.325,0.001-2.65,0.079-3.974,0.245C392.688,146.347,391.363,146.59,390.039,147.061z"
					/>
				<path style={{ fill: '#32338C' }} d="M397.987,139.113c-0.47,1.325-0.714,2.649-0.89,3.974c-0.167,1.324-0.244,2.649-0.245,3.974
					c-0.002,1.325,0.076,2.649,0.242,3.974c0.175,1.324,0.42,2.649,0.893,3.974c0.473-1.324,0.718-2.649,0.893-3.974
					c0.166-1.325,0.244-2.649,0.242-3.974c-0.001-1.325-0.079-2.649-0.245-3.974C398.701,141.762,398.457,140.438,397.987,139.113z"
					/>
				<path style={{ fill: '#32338C' }} d="M392.366,152.681c1.269-0.604,2.378-1.368,3.439-2.181c1.055-0.819,2.046-1.701,2.983-2.637
					c0.938-0.935,1.82-1.927,2.639-2.981c0.813-1.061,1.577-2.17,2.179-3.441c-1.271,0.602-2.381,1.366-3.441,2.179
					c-1.054,0.819-2.046,1.701-2.981,2.639c-0.936,0.938-1.818,1.929-2.637,2.983C393.735,150.303,392.97,151.412,392.366,152.681z"
					/>
				<path style={{ fill: '#32338C' }} d="M392.366,141.441c0.604,1.269,1.368,2.378,2.181,3.439c0.819,1.054,1.701,2.046,2.637,2.983
					c0.935,0.938,1.927,1.82,2.981,2.639c1.061,0.813,2.17,1.577,3.441,2.178c-0.602-1.271-1.366-2.381-2.179-3.441
					c-0.819-1.055-1.701-2.046-2.639-2.981c-0.937-0.936-1.929-1.818-2.983-2.637C394.745,142.809,393.636,142.045,392.366,141.441z
					"/>
			</g>
		</g>
		<g>
			<polygon style={{ fill: '#32338C' }} points="79.8,340.577 86.818,337.672 89.031,331.346 91.247,337.996 98.261,340.577 
				91.895,343.073 89.031,349.807 86.818,343.613 			"/>
			<g>
				<path style={{ fill: '#32338C' }} d="M113.351,299.789c-2.041,0.725-4.082,1.1-6.122,1.371c-2.04,0.256-4.082,0.376-6.122,0.378
					c-2.041,0.003-4.081-0.117-6.122-0.373c-2.041-0.27-4.082-0.646-6.123-1.376c2.041-0.729,4.082-1.106,6.123-1.375
					c2.041-0.256,4.081-0.376,6.122-0.373c2.041,0.002,4.082,0.121,6.122,0.378C109.27,298.689,111.31,299.064,113.351,299.789z"/>
				<path style={{ fill: '#32338C' }} d="M101.106,287.545c0.725,2.041,1.101,4.082,1.371,6.122c0.257,2.041,0.376,4.082,0.378,6.122
					c0.003,2.041-0.117,4.082-0.373,6.122c-0.27,2.041-0.647,4.082-1.376,6.122c-0.729-2.04-1.106-4.082-1.375-6.122
					c-0.256-2.04-0.376-4.081-0.373-6.122c0.002-2.04,0.121-4.081,0.378-6.122C100.006,291.626,100.382,289.586,101.106,287.545z"/>
				<path style={{ fill: '#32338C' }} d="M109.765,308.447c-1.955-0.931-3.664-2.108-5.298-3.36c-1.624-1.262-3.152-2.62-4.596-4.062
					c-1.445-1.441-2.804-2.968-4.065-4.593c-1.253-1.634-2.429-3.343-3.356-5.302c1.959,0.927,3.668,2.104,5.302,3.357
					c1.624,1.262,3.152,2.62,4.593,4.065c1.441,1.444,2.8,2.972,4.062,4.596C107.657,304.783,108.834,306.492,109.765,308.447z"/>
				<path style={{ fill: '#32338C' }} d="M109.765,291.131c-0.931,1.956-2.108,3.664-3.36,5.298c-1.262,1.624-2.621,3.152-4.062,4.596
					c-1.441,1.445-2.969,2.803-4.593,4.065c-1.634,1.252-3.343,2.429-5.302,3.356c0.927-1.959,2.104-3.668,3.356-5.301
					c1.262-1.625,2.62-3.152,4.065-4.593c1.444-1.442,2.972-2.8,4.596-4.062C106.101,293.239,107.81,292.062,109.765,291.131z"/>
			</g>
			<g>
				<path style={{ fill: '#32338C' }} d="M129.249,327.149c-1.325,0.471-2.649,0.714-3.974,0.89c-1.325,0.166-2.649,0.244-3.974,0.245
					c-1.325,0.002-2.649-0.076-3.974-0.242c-1.325-0.175-2.649-0.42-3.974-0.893c1.325-0.473,2.649-0.718,3.974-0.893
					c1.325-0.166,2.649-0.244,3.974-0.242c1.325,0.001,2.65,0.079,3.974,0.245C126.6,326.435,127.924,326.679,129.249,327.149z"/>
				<path style={{ fill: '#32338C' }} d="M121.301,319.202c0.47,1.325,0.714,2.649,0.89,3.974c0.167,1.324,0.244,2.649,0.245,3.974
					c0.002,1.325-0.076,2.649-0.242,3.974c-0.175,1.324-0.42,2.649-0.893,3.974c-0.473-1.324-0.718-2.649-0.893-3.974
					c-0.166-1.325-0.244-2.649-0.242-3.974c0.001-1.325,0.079-2.649,0.245-3.974C120.587,321.851,120.831,320.526,121.301,319.202z"
					/>
				<path style={{ fill: '#32338C' }} d="M126.922,332.769c-1.269-0.604-2.378-1.368-3.439-2.181c-1.055-0.819-2.046-1.701-2.983-2.637
					c-0.938-0.935-1.82-1.927-2.639-2.981c-0.813-1.061-1.577-2.17-2.179-3.441c1.271,0.602,2.381,1.366,3.442,2.179
					c1.054,0.819,2.046,1.701,2.981,2.639c0.935,0.938,1.817,1.929,2.636,2.983C125.553,330.391,126.317,331.5,126.922,332.769z"/>
				<path style={{ fill: '#32338C' }} d="M126.922,321.53c-0.604,1.269-1.368,2.378-2.181,3.439c-0.819,1.054-1.701,2.046-2.636,2.983
					c-0.936,0.938-1.927,1.82-2.981,2.639c-1.061,0.813-2.17,1.577-3.442,2.178c0.602-1.271,1.366-2.381,2.179-3.441
					c0.819-1.055,1.701-2.046,2.639-2.981c0.937-0.936,1.929-1.818,2.983-2.637C124.543,322.898,125.652,322.134,126.922,321.53z"/>
			</g>
		</g>
		<g>
			<polygon style={{ fill: '#32338C' }} points="91.765,60.422 98.783,57.518 100.995,51.192 103.211,57.842 110.226,60.422 
				103.859,62.918 100.995,69.653 98.783,63.458 			"/>
			<g>
				<path style={{ fill: '#32338C' }} d="M113.24,98.433c-2.041,0.725-4.082,1.1-6.122,1.371c-2.04,0.256-4.082,0.375-6.122,0.378
					c-2.041,0.003-4.081-0.117-6.122-0.373c-2.041-0.27-4.082-0.646-6.123-1.376c2.041-0.729,4.082-1.106,6.123-1.375
					c2.041-0.256,4.081-0.376,6.122-0.373c2.041,0.002,4.082,0.121,6.122,0.378C109.158,97.333,111.199,97.709,113.24,98.433z"/>
				<path style={{ fill: '#32338C' }} d="M100.995,86.189c0.725,2.041,1.101,4.081,1.371,6.122c0.257,2.041,0.376,4.081,0.378,6.122
					c0.003,2.041-0.117,4.082-0.373,6.122c-0.27,2.041-0.647,4.082-1.376,6.122c-0.729-2.04-1.106-4.082-1.375-6.122
					c-0.256-2.041-0.376-4.081-0.373-6.122c0.002-2.041,0.121-4.081,0.378-6.122C99.895,90.271,100.271,88.23,100.995,86.189z"/>
				<path style={{ fill: '#32338C' }} d="M109.654,107.092c-1.955-0.931-3.664-2.108-5.298-3.36c-1.624-1.262-3.152-2.62-4.596-4.062
					c-1.445-1.441-2.804-2.968-4.065-4.593c-1.253-1.634-2.429-3.343-3.356-5.302c1.959,0.927,3.668,2.104,5.302,3.357
					c1.624,1.262,3.152,2.62,4.593,4.065c1.441,1.444,2.8,2.972,4.062,4.596C107.546,103.427,108.723,105.136,109.654,107.092z"/>
				<path style={{ fill: '#32338C' }} d="M109.654,89.776c-0.931,1.956-2.108,3.664-3.36,5.298c-1.262,1.624-2.621,3.152-4.062,4.596
					c-1.441,1.445-2.969,2.804-4.593,4.065c-1.634,1.252-3.343,2.429-5.302,3.356c0.927-1.959,2.104-3.668,3.356-5.301
					c1.262-1.625,2.62-3.152,4.065-4.593c1.444-1.442,2.972-2.8,4.596-4.062C105.989,91.883,107.699,90.706,109.654,89.776z"/>
			</g>
			<g>
				<path style={{ fill: '#32338C' }} d="M144.423,72.059c-1.325,0.471-2.649,0.714-3.974,0.89c-1.325,0.166-2.65,0.244-3.974,0.245
					c-1.324,0.002-2.649-0.076-3.974-0.242c-1.325-0.175-2.649-0.42-3.974-0.893c1.325-0.473,2.649-0.718,3.974-0.893
					c1.325-0.166,2.649-0.244,3.974-0.242c1.325,0.001,2.65,0.079,3.974,0.245C141.773,71.344,143.098,71.588,144.423,72.059z"/>
				<path style={{ fill: '#32338C' }} d="M136.474,64.111c0.47,1.325,0.714,2.649,0.89,3.974c0.167,1.325,0.244,2.649,0.245,3.974
					c0.002,1.325-0.076,2.649-0.242,3.974c-0.175,1.325-0.42,2.649-0.893,3.974c-0.473-1.324-0.718-2.649-0.893-3.974
					c-0.166-1.325-0.244-2.649-0.242-3.974c0.001-1.325,0.079-2.649,0.245-3.974C135.76,66.76,136.004,65.436,136.474,64.111z"/>
				<path style={{ fill: '#32338C' }} d="M142.095,77.679c-1.269-0.604-2.378-1.368-3.439-2.181c-1.054-0.819-2.046-1.701-2.983-2.637
					c-0.938-0.935-1.82-1.927-2.639-2.981c-0.813-1.061-1.577-2.17-2.179-3.442c1.271,0.602,2.381,1.366,3.441,2.179
					c1.054,0.819,2.046,1.701,2.981,2.639c0.936,0.938,1.818,1.929,2.637,2.983C140.726,75.3,141.491,76.409,142.095,77.679z"/>
				<path style={{ fill: '#32338C' }} d="M142.095,66.439c-0.604,1.269-1.368,2.378-2.181,3.439c-0.819,1.054-1.701,2.046-2.637,2.983
					c-0.936,0.938-1.927,1.82-2.981,2.639c-1.061,0.813-2.17,1.576-3.441,2.178c0.602-1.271,1.366-2.381,2.179-3.441
					c0.819-1.055,1.701-2.046,2.639-2.981c0.937-0.936,1.929-1.818,2.983-2.637C139.716,67.807,140.826,67.043,142.095,66.439z"/>
			</g>
		</g>
	</g>
</g>
</svg>

    );
  }
}

export default FeelingProud;
